// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AOWFQnBL2S0vPtpJ2qrn{padding:24px}.ldysu52BwzDL1UqFxXR7{display:inline-flex;gap:18px;width:100%;padding-top:10px}.mbG5DhNEfXttK8X8XEK_{min-width:120px}`, "",{"version":3,"sources":["webpack://./src/commun/composants/ConfirmationPopIn/ConfirmationPopin.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CAGF,sBACE,mBAAA,CACA,QAAA,CACA,UAAA,CACA,gBAAA,CAGF,sBACE,eAAA","sourcesContent":[".container {\n  padding: 24px;\n}\n\n.buttonBar {\n  display: inline-flex;\n  gap: 18px;\n  width: 100%;\n  padding-top: 10px;\n}\n\n.btnMinWidth {\n  min-width: 120px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AOWFQnBL2S0vPtpJ2qrn`,
	"buttonBar": `ldysu52BwzDL1UqFxXR7`,
	"btnMinWidth": `mbG5DhNEfXttK8X8XEK_`
};
export default ___CSS_LOADER_EXPORT___;
